import styled from 'styled-components'

export const RotatingContainer = styled.div<{$isSelected: boolean; $rotateFromSide?: boolean}>`
    display: flex;
    align-items: center;
    justify-content: center;
    transition: transform 0.2s ease;
    transform: rotate(
        ${({$isSelected, $rotateFromSide}) => {
            if ($rotateFromSide) {
                return $isSelected ? '0deg' : '-90deg'
            }
            return $isSelected ? '180deg' : '0deg'
        }}
    );
`
